<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Dettaglio testata questionario #' + this.$route.params.id : 'Nuova testata questionario')">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio || this.$route.params.id == null)">
                        <b-row class="my-1">
                            <b-col sm="3"><label for="titolo">Titolo:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="questionario.titolo" id="titolo" type="text"></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-1">
                            <b-col sm="3"><label for="note">Note:</label></b-col>
                            <b-col sm="9">
                                <b-form-textarea v-model="questionario.note" id="note" rows="3"></b-form-textarea>
                            </b-col>
                        </b-row>                        
                        <b-row class="my-1">
                            <b-col sm="3"><label for="flagsta">Questionario attivo:</label></b-col>
                            <b-col sm="9">
                                <b-form-select v-model="questionario.flagsta" :options="options_attivo" id="flagsta">

                                </b-form-select>
                            </b-col>
                        </b-row>                                                
                        <b-row class="my-1" v-if="questionario.id != null">
                            <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="questionario.datains" id="datains" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>                                
                        <b-row class="my-1" v-if="questionario.id != null">
                            <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                            <b-col sm="9">
                                <b-form-input v-model="questionario.uteins" id="uteins" type="text" disabled></b-form-input>
                            </b-col>
                        </b-row>    
                        <b-row class="my-3">
                            <b-col sm="6" offset-sm="3">
                                <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                    <div v-if="questionario.id != null">
                                        Salva
                                    </div>
                                    <div v-else>
                                        Inserisci
                                    </div>
                                </b-button>
                            </b-col>                                    
                        </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

export default {
    name: 'appdettaglio',
    data: function () {
        return {
            
            namespace: NAMESPACE,
            questionario: {
                id: this.$route.params.id || null,                
                titolo: '',
                note: '',
                flagsta: 'S',
                datains: null,
                uteins: ''
            },      
            options_attivo: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],                   
            error: '',
            showerror: false,
            showdettaglio: false,
            dismissSecs: 2,
            dismissCountDown: 0,                 
        };
    },
    methods: {                
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },

        insert() {

            if (this.questionario.titolo == '') {
                this.showerror = true;
                this.error = "Compilare il campo 'Titolo'!";                            
            } else {
                
                var json = JSON.stringify(this.questionario);

                var appdettaglio = this;

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/testataquestionario', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.questionario = res[0];
                                    this.showerror = false;
                                    this.showdettaglio = true; //anche se non dovrebbe servire                                 
                                    this.dismissCountDown = this.dismissSecs;

                                    this.$router.replace('/app/testataquestionario/' + this.questionario.id);

                                    setTimeout(function() {
                                        //window.history.back();
                                        appdettaglio.$router.go(-1);
                                    }, 2500);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

        }
    },
    created: function () {
        
        if(!ctrlVismenu("Q")){
            this.$router.replace('/accessdenied');
            return;
        }

        var id = this.questionario.id; //se è la prima volta si prova a prendere da getid 
        var token = localStorage.getItem('token');

        if (id != null) {
            
            var appdettaglio = this;

            this.axios.get(NAMESPACE + 'rest/questionaridomande/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {
                                appdettaglio.questionario = res[0];
                                appdettaglio.showdettaglio = true;


                            } else {
                                throw new Error("Errore dati non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        }

    },
    mounted: function() { 
        
    }

}
</script>
